import { render, staticRenderFns } from "./VouchersForm.vue?vue&type=template&id=2a254708&scoped=true&"
import script from "./VouchersForm.vue?vue&type=script&lang=js&"
export * from "./VouchersForm.vue?vue&type=script&lang=js&"
import style0 from "./VouchersForm.vue?vue&type=style&index=0&id=2a254708&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a254708",
  null
  
)

export default component.exports